import React, { useState } from 'react';
import SurgeFactorsInput from './surge-factors-input';
import { ReactComponent as TitleIcon } from 'assets/icons/update-surge-modal-icon.svg';
import { Button, BaseModal } from '@cokitchen/cokitchen-components';
const SurgeFactorsSideModal = ({ show, onClose }: { show: boolean; onClose: () => void }) => {
  const [loading] = useState(false);
  const factors = [
    { name: 'Rider shortage', value: '1.1x' },
    { name: 'Mid-high traffic', value: '1.2x' },
    { name: 'Heavy Rain', value: '1.25x' },
    { name: 'Election days', value: '1.25x' },
    { name: 'Heavy traffic', value: '1.25x' }
  ];
  const updateFactors = (newVal: string) => {
    console.log('update factors', { newVal });
  };
  return (
    <BaseModal
      position='right'
      isOpen={show}
      onRequestClose={onClose}
      titleIcon={<TitleIcon />}
      title='Surge factor'
      footer={
        <Button small color='primary' variant='block' loading={loading} onClick={onClose}>
          Confirm
        </Button>
      }>
      <div>
        {factors.map(({ name, value }, index) => (
          <div key={index}>
            <SurgeFactorsInput factor={name} value={value} onChange={updateFactors} />
          </div>
        ))}
      </div>
    </BaseModal>
  );
};

export default SurgeFactorsSideModal;
